import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';

import { Message, MenuItem } from 'primeng/components/common/api';
import { UserService } from '../../../services/user/user.service';
import { EditUserModel, User } from '../../../models/outModels/User';

import 'rxjs/add/operator/switchMap';
import { AutoCompleteEvent } from '../../../models/Utility/autoCompleteEvent';
import { AuthenticationService } from '../../../services/authentication/authentication.service';
import { SelectItem } from 'primeng/components/common/selectitem';
import { StorageService } from "../../../services/system/storage.service";
import { BusinessService as BusinessCategoryService } from "../../../services/business/business-category.service";
import { SubscriptionPlanService } from "../../../services/subscription.service";
import { ConfirmationService } from "primeng/components/common/confirmationservice";
import { UpdateUserSubscription } from '../../../models/inModels/Subscription';

@Component({
	selector: 'app-users-edit',
	templateUrl: './users-edit.component.html',
	styleUrls: ['./users-edit.component.css']
})

export class UsersEditComponent implements OnInit {
	user: User;
	model: EditUserModel;
	loading = false;
	messages: Message[];
	keyMsgs: Message[];
	sections: MenuItem[];
	profile: boolean;
	roles;
	selectedRole;
	valid = false;
	enterKey = false;
	groups: SelectItem[];
	dropDownEvent: AutoCompleteEvent;
	categories: SelectItem[];
	programmes: SelectItem[];
	clients;
	selectedClient;
	selectedProgramme;
	profileTypes;
	selectedProfileType;

	plans: SelectItem[];
	selectedPlan;

	coaches: any[];
	selectedCoach;
	programmeIsActive = true;

	constructor(
		private route: ActivatedRoute,
		private router: Router,
		private userService: UserService,
		private auth: AuthenticationService,
		public storageService: StorageService,
		public businessService: BusinessCategoryService,
		private subscriptionService: SubscriptionPlanService,
		private confirmationService: ConfirmationService) {
		this.roles = [
			{
				label: 'Administrator',
				value: 'Administrator'
			},
			{
				label: 'User',
				value: 'User'
			}
		];
		this.getGroups();
		this.getCategories();
	}

	ngOnInit() {
		this.getUser();
		this.getCoaches();

		this.dropDownEvent = {
			query: ''
		};

		this.route.paramMap.subscribe(params => {
			this.profile = params.get('Id') == null;
		});
	}

	getUser() {
		this.loading = true;
		this.route.paramMap
			.switchMap((params: ParamMap) => params.get('Id') != undefined ? this.userService.getUser(params.get('Id')) : this.userService.getCurrentUser())
			.subscribe(user => {
				this.user = user;
				this.model = new EditUserModel(user);

				if (user.Role !== undefined && user.Role !== '') {
					this.selectedRole = {
						label: user.Role,
						value: user.Role
					};
				} else {
					this.selectedRole = {
						label: 'Select Role',
						value: ''
					};
				}

				if (user.ClientId != null) {
					this.selectedClient = {
						label: user.Client,
						value: user.ClientId
					};
				}
				if (user.ProgrammeName != null) {
					this.selectedProgramme = {
						label: user.ProgrammeName,
						value: user.ProgrammeId
					};
				}
				this.businessService.getProgrammeStatus(this.model.Id).then(status => {
					this.programmeIsActive = status.IsActive;
					this.model.ProgrammeId = status.ProgrammeId;
				});

				this.loading = false;
			}, error => {
				this.loading = false;
				this.messages = [];
				this.messages.push({ severity: 'error', summary: 'Error', detail: error });
			});

	}

	goBack(): void {
		this.router.navigate(['/users']);
	}

	save(): void {
		this.model.DateOfBirth = this.auth.convertToUtc(this.model.DateOfBirth);
		this.loading = true;
		this.model.Gender = this.model.GenderId;
		console.log("UPDATED DETAILS: ", this.model);
		this.userService.update(this.model).then(
			user => {
				this.loading = false;
				this.model = new EditUserModel(user);

				console.log(this.model);
				this.messages = [];
				this.messages.push({ severity: 'success', summary: 'Success', detail: 'User details saved.' });
			},
			error => {
				this.loading = false;
				this.messages = [];
				this.messages.push({ severity: 'error', summary: 'Error', detail: error });
			}
		);
	}

	getGroups() {
		this.loading = true;
		this.userService.getGroupsList().then(
			x => {
				this.groups = x;
				this.loading = false;
			},
			error => {
				this.loading = false;
				this.messages = [];
				this.messages.push({ severity: 'error', summary: 'Error', detail: error });
			});
	}

	getCategories() {
		this.loading = true;
		this.businessService.getDropdownList().then(
			x => {
				this.categories = x;
				this.loading = false;
			},
			error => {
				this.loading = false;
				this.messages = [];
				this.messages.push({ severity: 'error', summary: 'Error', detail: error });
			});
	}

	getProfileTypes(event) {
		this.userService.getProfileTypeDropDown(event).then(
			x => {
				this.profileTypes = x;
			},
			error => {
				this.messages = [];
				this.messages.push({ severity: 'error', summary: 'Error', detail: error });
			});
	}

	setProfileType() {
		this.model.ProfileType = this.selectedProfileType.value;
	}

	handleImage(event): void {
		var result = this.storageService.handleSuccess(event);
		this.model.ProfilePictureId = result.PublicId;
		this.loading = false;
	}

	handleError(event): void {
		this.loading = false;
		this.messages = [];
		this.storageService.handleError(event, this.messages);
	}

	removeImage(): void {
		this.model.ProfilePictureId = null;
		this.loading = false;
	}

	initClientDropDown(event): void {
		this.businessService.getDropdownClients(event).then(
			result => {
				if (result.length == 0) {
					this.emptyMessage = "Client not found, press enter to create";
				}
				this.clients = result;
			},
			error => {
				this.messages = [];
				this.messages.push({ severity: 'error', summary: 'Error', detail: error });
			}
		);
	}

	setClient(): void {
		this.model.Client = this.selectedClient.value;
		this.emptyMessage = null;
	}

	setProgramme(): void {
		this.model.ProgrammeId = this.selectedProgramme.value;
		this.emptyMessage = null;
	}

	setCoach(): void {
		this.model.AssignedCoachId = this.selectedCoach.value;
		this.emptyMessage = null;
	}


	initProgrammeDropDown(event): void {
		this.userService.getProgrammesDropDown(event).then(
			result => {
				this.programmes = result;
			},
			error => {
				this.messages = [];
				this.messages.push({ severity: 'error', summary: 'Error', detail: error });
			}
		);
	}

	emptyMessage = "Client not found, press enter to create";
	addClient(event) {
		console.log(event.target.value);
		if (event.target.value == undefined || event.target.value === '') {
			this.selectedClient = null;
			this.model.Client = this.selectedClient;
		}

		if (event.key === 'Enter') {
			this.loading = true;
			this.businessService.getOrAddClient(event.target.value).then(
				result => {
					this.clients = [];
					this.clients.push(result);
					this.selectedClient = result;
					this.setClient();

					this.loading = false;
				},
				error => {
					this.loading = true;
				});
		}
	}

	initPlanDropDown(event) {
		this.subscriptionService.getDropdown(event).then(
			x => {
				this.plans = x;
			},
			error => {
				this.messages = [];
				this.messages.push({ severity: 'error', summary: 'Error', detail: error });
			});
	}

	updateSubscription(): void {
		this.confirmationService.confirm({
			message: `Are you sure you want to change this users subscription, It will reset the users Subscription start date and end date according to the plan selected.`,
			header: 'Confirmation',
			acceptLabel: "yes",
			rejectLabel: "no",
			accept: () => {
				this.loading = true;
				let model = new UpdateUserSubscription();
				model.PlanId = this.selectedPlan.value;
				model.UserId = this.user.Id;

				this.subscriptionService.updateUserSubscription(model).then(
					x => {
						this.selectedPlan = {};
						this.getUser();
						this.loading = false;
					},
					error => {
						this.loading = false;
						this.messages = [];
						this.messages.push({ severity: 'error', summary: 'Error', detail: error });
					});
			}
		});
	}

	removeSubscription(): void {
		this.confirmationService.confirm({
			message: `Are you sure you want to remove this users subscription. They will loose access to the portal.`,
			header: 'Confirmation',
			acceptLabel: "yes",
			rejectLabel: "no",
			accept: () => {
				this.loading = true;
				this.subscriptionService.removeUserSubscription(this.user.Id).then(
					x => {
						this.getUser();
						this.loading = false;
					},
					error => {
						this.loading = false;
						this.messages = [];
						this.messages.push({ severity: 'error', summary: 'Error', detail: error });
					});
			}
		});
	}

	getCoaches() {
		this.businessService.getListOfCoaches().then(
			(data) => {
				this.coaches = data;
			}
		)
	}

async toggleProgramme() {
    const payload = {
        userId: this.model.Id,
        programmeId: this.model.ProgrammeId,
        isActive: this.programmeIsActive
    };
    await this.businessService.updateProgrammeStatus(payload);
}

}



// WEBPACK FOOTER //
// ./src/app/components/users/users-edit/users-edit.component.ts